import { Injectable } from '@angular/core';
import { IdentityDTO } from '../api/api';

@Injectable({ providedIn: 'root' })
export class HierarchyService {
  getObjectFromHierarchyArrayById<T extends IdentityDTO, K extends keyof T>(
    arr: T[],
    anySelection: { id: any },
    arrayFieldName: K
  ): T | null {
    if (!arr || !anySelection?.id) {
      return null;
    }

    for (const ele of arr) {
      if (ele.id === anySelection.id) {
        return ele;
      }

      const children = ele[arrayFieldName] as T[] | undefined; // access child property

      if (children?.length) {
        // filter undefined an length of 0
        const found = this.getObjectFromHierarchyArrayById<T, K>(children, anySelection, arrayFieldName);
        if (found) {
          return found;
        }
      }
    }
    return null;
  }

  removeObjectFromHierarchyArrayById<T extends IdentityDTO, K extends keyof T>(
    arr: T[],
    anySelection: { id: any },
    arrayFieldName: K
  ): T | null {
    if (!arr || !anySelection?.id) {
      return null;
    }

    const index = arr.findIndex(ele => ele.id === anySelection.id);
    if (index !== -1) {
      return arr.splice(index, 1)[0]; // Remove and return the deleted element
    }

    for (const ele of arr) {
      const children = ele[arrayFieldName] as T[] | undefined;

      if (children?.length) {
        const removed = this.removeObjectFromHierarchyArrayById<T, K>(children, anySelection, arrayFieldName);
        if (removed) {
          return removed;
        }
      }
    }

    return null;
  }
}
